export default "__VITE_ASSET__Dp2eBKv1__"